import { useTranslation } from "react-i18next";
import { HowItWorksSidebar } from "./HowItWorksSidebar";
import { ProcessSteps } from "./ProcessSteps";
import { howItWorksTrns } from "../trns";

export const HowItWorks = () => {
  const { t } = useTranslation();

  return (
    <section className="container flex flex-col-reverse items-start justify-center md:flex-row md:justify-between gap-10 pt-10 lg:pt-20 default:overflow-visible">
      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-5">
          <h2 className="text-purple-base">{t(howItWorksTrns.title)}</h2>

          <p
            className="text-justify"
            dangerouslySetInnerHTML={{ __html: t(howItWorksTrns.description) }}
          />
        </div>

        <ProcessSteps />
      </div>

      <HowItWorksSidebar />
    </section>
  );
};
